import { type AppDispatch } from "features/Application/globaltypes/redux";
import packsDataService from "features/Licensing/Packs/services/packsDataService";
import { errPayment, gotPayment, startPayment } from "../slices/paymentProcessingSlice";
import { type ProcessPaymentRequest } from "features/Licensing/Packs/types/requests";

export const processPayment = (data: ProcessPaymentRequest) => async (dispatch: AppDispatch) => {
  try {
    dispatch(startPayment());

    const response = await packsDataService.processPayment(data);

    if ("errorMessage" in response) {
      dispatch(errPayment(response.errorMessage || "Payment processing failed"));
    } else {
      dispatch(gotPayment(response));
    }
  } catch (error) {
    dispatch(errPayment("An error occurred while processing your payment. Please try again."));
    throw error;
  }
};
